const FETCH_ERROR = 'industries/FETCH_ERROR'
const FETCH_REQUESTED = 'industries/FETCH_REQUESTED'
const FETCH_SUCCESS = 'industries/FETCH_SUCCESS'

const TOGGLE = 'industries/TOGGLE'

export default {
  FETCH_ERROR,
  FETCH_REQUESTED,
  FETCH_SUCCESS,
  TOGGLE
}
